import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { ProcedureName98 } from "../../assets/data/Constants";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { GlobalContext } from "../../context/globalContext";
import { httpAPI_AGE007 } from "./api/request";
import { fakeTableList } from "./parts";
import _ from "lodash";
import "./_style.scss";

/**
 * SCRC100004 代行処理依頼詳細
 * @returns JSX.Element
 */
const SCRC100004 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const [statecorpInfoList, setStatecorpInfoList] = useState<any>([]);

  // 初期表示
  const handleInit = async () => {
    // 代行入力依頼参照API 呼び出し
    try {
      const res = await httpAPI_AGE007({
        taskId: location.state?.taskId,
      });

      if (res.resultCd === "I0000") {
        let resArr = _.cloneDeep(fakeTableList);

        // 代行者
        resArr.find((item) => item.keyword === "agentUserName")!.text =
          res.name;

        // 代行内容
        resArr.find((item) => item.keyword === "agentContent")!.text =
          res.formerTaskTypeName;

        // 対象施設
        let agentFacilityName = resArr.find(
          (item) => item.keyword === "agentFacilityName"
        )!;
        agentFacilityName.text = res.facilityName;
        agentFacilityName.showLine =
          res.formerTaskType !== ProcedureName98["退職届"];

        // 退職者名
        let staffName = resArr.find((item) => item.keyword === "staffName")!;
        staffName.text = (res.staffNo ?? "") + ":" + (res.staffName ?? "");
        staffName.showLine = res.formerTaskType === ProcedureName98["退職届"];

        // タイトル
        resArr.find((item) => item.keyword === "requestTitle")!.text =
          res.taskTitle;

        // 対応期限
        resArr.find((item) => item.keyword === "dueDate")!.text = res.dueDate;

        // 本文
        resArr.find((item) => item.keyword === "requestContent")!.text =
          res.taskText?.replace(/\\r\\n/g, "\n");

        // 実績
        let title = resArr.find((item) => item.keyword === "lineTitle")!;
        title.showLine = !!res.agentAchievementList?.length;
        title.lineTitle = `実績完了 （${res.latestHandleDate}）`;
        res.agentAchievementList?.forEach((item) => {
          resArr.push({
            type: "text",
            keyword: item.staffNo,
            title: (item.staffName ?? "") + "さん",
            text: item.detail,
          });
        });

        setStatecorpInfoList(resArr);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="SCRC100004" data-testid="SCRC100004PageForTest">
      <TkFakeTable
        list={statecorpInfoList}
        ruleSchema={{}}
        showButton={false}
        buttonGroup={<TkBackButton />}
      />
    </Box>
  );
};

export default SCRC100004;
